import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LoanRemarksCreateModalSF from '../../../components/superUser/loan/util/LoanRemarksCreateModalSF'
import LoanRemarksUpdateModalSF from '../../../components/superUser/loan/util/LoanRemarksUpdateModalSF'
import './ReportCardPage.css'

const SecurityRemarksPageUI = ({ context, errorList,
  loan, onRefreshClick, createMode, onCancelRemarksClick, onCreateRemarksClick, objectCode, objectId, securityRemarksList,
  updateRemarksMode, onUpdateRemarksClick, selectedRemarks, selectedRemarksId
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_repc' topnav='loans'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='compliance'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Security remarks</b></span>
            </span>
          }
          right={<span />}
        />

        <SecurityRemarksUI
          loan={loan}
          context={context}
          createMode={createMode}
          onCreateRemarksClick={onCreateRemarksClick}
          onCancelRemarksClick={onCancelRemarksClick}
          onRefreshClick={onRefreshClick}
          objectCode={objectCode}
          objectId={objectId}
          securityRemarksList={securityRemarksList}
          updateRemarksMode={updateRemarksMode}
          onUpdateRemarksClick={onUpdateRemarksClick}
          selectedRemarks={selectedRemarks}
          selectedRemarksId={selectedRemarksId}
        />

      </div>
    }
  </SuperUserLoanPageUI>

const SecurityRemarksUI = ({ context, loan, onRefreshClick,
  createMode, onCancelRemarksClick, onCreateRemarksClick, objectCode, objectId, securityRemarksList,
  updateRemarksMode, onUpdateRemarksClick, selectedRemarks, selectedRemarksId
}) =>
  <CardUI>
    <div className='g_flex_left g_flex_h'>
      <span className="icon icon-plus g_large g_cursor_pointer" onClick={onCreateRemarksClick}
        data-object-code='penal_interest' data-object-id='penal_interest'> Add remarks</span>
    </div>

    {
      securityRemarksList && securityRemarksList.map((remarks, i) =>
        <div key={i}>
          <span className='g_m_left_100 g_muted'>{remarks.remarksDateF}: {remarks.remarks}</span>
          <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onUpdateRemarksClick}
            data-object-id='penal_interest' data-date={remarks.remarksDateF}
            data-remarks={remarks.remarks} data-remarks-id={remarks.remarksId}></span>
        </div>
      )
    }

    <LoanRemarksCreateModalSF
      context={context} loan={loan}
      objectCode={objectCode} objectId={objectId}
      updateMode={createMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick}
    />

    <LoanRemarksUpdateModalSF
      context={context} loan={loan}
      selectedRemarks={selectedRemarks} selectedRemarksId={selectedRemarksId}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick}
    />
  </CardUI>

export default SecurityRemarksPageUI
